const GLOBAL_EXPERIMENT_CONFIG = {
  checkGlobalHoldoutGroup: false,
  apiTimeout: 2000,
  cacheMinutes: 15
};

export default GLOBAL_EXPERIMENT_CONFIG;
